// @flow
import OrgsSettingsPage, { dataKey } from './OrgsSettingsPage';

export default OrgsSettingsPage;
export { dataKey };
